import { render, staticRenderFns } from "./CardPrimary.vue?vue&type=template&id=d33dea90&scoped=true"
import script from "./CardPrimary.vue?vue&type=script&lang=js"
export * from "./CardPrimary.vue?vue&type=script&lang=js"
import style0 from "./CardPrimary.vue?vue&type=style&index=0&id=d33dea90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d33dea90",
  null
  
)

export default component.exports